export enum ErrorType {
  Error,
  Warning,
  Success,
  Info
}
